import React from 'react';
import { AppSmith } from 'components/appsmith/appsmith';

export function EditPlanGroups(props) {
  return (
    <AppSmith title="Edit Plan Groups" pageId="61634765ea18372f05105973" />
  );
}
